module.exports = __webpack_public_path__ + "img/austria-logo-icon.06533429.png";